import * as React from "react";
import { Button, Navbar, NavbarGroup } from "@blueprintjs/core";

import CreateAttributeLabel from "./CreateAttributeLabel";
import InspectorHeader from "./InspectorHeader";

import ApiLayers from "api/layers";

const AnnotationLayerInspector = ({ layer, closeInspector }) => {
  const table = [
    { label: "Total Annotations", property: layer.annotations.length },
  ];

  return (
    <>
      <InspectorHeader model={layer} closeInspector={closeInspector} />
      <CreateAttributeLabel layer={layer} />
      {/* <Navbar>
        <NavbarGroup>
          {layer.archived && (
            <Button
              icon="undo"
              text="Undo Deleted Layer"
              intent="success"
              disabled={!layer.archived}
              onClick={() => ApiLayers.unarchiveAnnotationLayer(layer.id)}
            />
          )}
        </NavbarGroup>
        <NavbarGroup align="right">
          <Button
            icon="trash"
            text="Delete Layer"
            intent="danger"
            disabled={layer.archived}
            onClick={() => ApiLayers.archiveAnnotationLayer(layer.id)}
          />
        </NavbarGroup>
      </Navbar> */}
    </>
  );
};

export default AnnotationLayerInspector;
